import { shopManagerApi } from 'configs';
import api from 'configs/api';
import { convertToSearchCriteria } from 'helpers/api';
import {
  getCustomerSubscriptionsListStart,
  getCustomerSubscriptionsListSuccess,
  getCustomerSubscriptionsListFailed,
  getCustomerSubscriptionStart,
  getCustomerSubscriptionSuccess,
  getCustomerSubscriptionFailed,
  editCustomerSubscriptionStart,
  editCustomerSubscriptionSuccess,
  editCustomerSubscriptionFailed,
  getCustomerSubscriptionBillingInfoFailed,
  getCustomerSubscriptionBillingInfoStart,
  getCustomerSubscriptionBillingInfoSuccess,
  editCustomerSubscriptionBillingInfoFailed,
  editCustomerSubscriptionBillingInfoSuccess,
  editCustomerSubscriptionBillingInfoStart,
  getCustomerSubscriptionShippingStart,
  getCustomerSubscriptionShippingFailed,
  getCustomerSubscriptionShippingSuccess,
  editCustomerSubscriptionShippingStart,
  editCustomerSubscriptionShippingFailed,
  editCustomerSubscriptionShippingSuccess,
  getCustomerSubscriptionHistoryStart,
  getCustomerSubscriptionHistorySuccess,
  getCustomerSubscriptionHistoryFailed,
  billCustomerSubscriptionStart,
  billCustomerSubscriptionSuccess,
  billCustomerSubscriptionFailed,
  getSubscriptionStorePickupAddressFailed,
  getSubscriptionStorePickupAddressStart,
  getSubscriptionStorePickupAddressSuccess,
  downloadCustomerSubscriptionsStart,
  downloadCustomerSubscriptionsSuccess,
  downloadCustomerSubscriptionsFailed,
  editCustomerSubscriptionPriceStart,
  editCustomerSubscriptionPriceSuccess,
  editCustomerSubscriptionPriceFailed
} from 'redux/actions/customer_subscriptions';


export const getCustomerSubscriptionsListApi = async ({
  dispatch,
  sortDirection,
  sortField,
  pageSize,
  currentPage,
  searchConditions,
  filterConditions
}) => {
  try {
    dispatch(getCustomerSubscriptionsListStart());
    const params = convertToSearchCriteria({
      searchConditions,
      filterConditions,
      pageSize,
      currentPage,
      sortField,
      sortDirection
    });
    const { data } = await api.get(`${shopManagerApi}/store/subscription/search?${params}`);
    dispatch(getCustomerSubscriptionsListSuccess(data));
  } catch (e) {
    dispatch(getCustomerSubscriptionsListFailed(e));
  }
};

export const getCustomerSubscriptionApi = async ({dispatch, id}) => {
  try {
    dispatch(getCustomerSubscriptionStart());
    const { data } = await api.get(`${shopManagerApi}/store/subscription/${id}`);
    dispatch(getCustomerSubscriptionSuccess(data));
  } catch (e) {
    dispatch(getCustomerSubscriptionFailed(e));
  }
};

export const editCustomerSubscriptionApi = async ({dispatch, subscription}) => {
  try {
    dispatch(editCustomerSubscriptionStart());
    const { data } = await api.put(`${shopManagerApi}/store/subscription/${subscription.id}`, subscription);
    dispatch(editCustomerSubscriptionSuccess(data));
  } catch (e) {
    dispatch(editCustomerSubscriptionFailed(e));
  }
};

export const editCustomerSubscriptionPriceApi = async ({dispatch, subscriptionId, price}) => {
  try {
    dispatch(editCustomerSubscriptionPriceStart);
    const { data } = await api.put(`${shopManagerApi}/store/subscription/price/${subscriptionId}`, { price });
    dispatch(editCustomerSubscriptionPriceSuccess(data));
  } catch (e) {
    dispatch(editCustomerSubscriptionPriceFailed(e));
  }
};

export const getCustomerSubscriptionBillingInfoApi = async ({dispatch, id}) => {
  try {
    dispatch(getCustomerSubscriptionBillingInfoStart());
    const { data } = await api.get(`${shopManagerApi}/store/subscription/payment/${id}`);
    dispatch(getCustomerSubscriptionBillingInfoSuccess(data));
  } catch (e) {
    dispatch(getCustomerSubscriptionBillingInfoFailed(e));
  }
};

export const editCustomerSubscriptionBillingInfoApi = async ({dispatch, id, token}) => {
  try {
    dispatch(editCustomerSubscriptionBillingInfoStart());
    const { data } = await api.put(`${shopManagerApi}/store/subscription/payment/${id}/${token}`);
    dispatch(editCustomerSubscriptionBillingInfoSuccess(data));
  } catch (e) {
    dispatch(editCustomerSubscriptionBillingInfoFailed(e));
  }
};

export const getCustomerSubscriptionShippingApi = async ({dispatch, id}) => {
  try {
    dispatch(getCustomerSubscriptionShippingStart());
    const { data } = await api.get(`${shopManagerApi}/store/subscription/shipping/${id}`);
    dispatch(getCustomerSubscriptionShippingSuccess(data));
  } catch (e) {
    dispatch(getCustomerSubscriptionShippingFailed(e));
  }
};

export const editCustomerSubscriptionShippingApi = async ({dispatch, id, shipping}) => {
  try {
    dispatch(editCustomerSubscriptionShippingStart());
    const { data } = await api.put(`${shopManagerApi}/store/subscription/shipping/${id}`, shipping);
    dispatch(editCustomerSubscriptionShippingSuccess(data));
  } catch (e) {
    dispatch(editCustomerSubscriptionShippingFailed(e));
  }
};

export const getCustomerSubscriptionHistoryApi = async ({
  dispatch,
  id,
  sortDirection,
  sortField,
  pageSize,
  currentPage,
  searchConditions,
  filterConditions
}) => {
  try {
    dispatch(getCustomerSubscriptionHistoryStart());
    const params = convertToSearchCriteria({
      searchConditions,
      filterConditions: [
        ...filterConditions,
        {
          field: 'subscription_id',
          value: id,
          conditionType: 'eq'
        }
      ],
      pageSize,
      currentPage,
      sortField,
      sortDirection
    });
    const { data } = await api.get(`${shopManagerApi}/store/subscription-history?${params}`);
    dispatch(getCustomerSubscriptionHistorySuccess(data));
  } catch (e) {
    dispatch(getCustomerSubscriptionHistoryFailed(e));
  }
};

export const billCustomerSubscriptionApi = async ({dispatch, id}) => {
  try {
    dispatch(billCustomerSubscriptionStart());
    const { data } = await api.post(`${shopManagerApi}/store/subscription/${id}/bill`);
    dispatch(billCustomerSubscriptionSuccess(data));
  } catch (e) {
    dispatch(billCustomerSubscriptionFailed(e));
  } finally {
    dispatch(getCustomerSubscriptionStart());
    const { data } = await api.get(`${shopManagerApi}/store/subscription/${id}`);
    dispatch(getCustomerSubscriptionSuccess(data));
  }
};

export const getSubscriptionStorePickupAddressApi = async ({dispatch}) => {
  try {
    dispatch(getSubscriptionStorePickupAddressStart());
    const data = await api.get(`${shopManagerApi}/store/pos/list`);
    dispatch(getSubscriptionStorePickupAddressSuccess(data));
  } catch (e) {
    dispatch(getSubscriptionStorePickupAddressFailed(e));
  }
};

export const downloadCustomerSubscriptionsApi = async ({ dispatch }) => {
  try {
    dispatch(downloadCustomerSubscriptionsStart());

    const {data} = await api({
      method: 'get',
      url: `${shopManagerApi}/store/subscriptions/download-report`,
      responseType: 'blob'
    });

    const file = URL.createObjectURL(data);
    window.location.assign(file);

    dispatch(downloadCustomerSubscriptionsSuccess(data));
  } catch (e) {
    dispatch(downloadCustomerSubscriptionsFailed(e));
  }
};
